export enum Routes {
    Business = '/organization/{id}/businesses',
    Projects = '/organization/{id}/projects',
    Folders = '/organization/{id}/folders',
    ManageUserOrganization = '/organization/{id}/users',
    ManageUserBusinesses = '/organization/{id}/users/businesses',
    ManageInvitations = '/organization/{id}/users/invitations',
    ManageRequests = '/organization/{id}/users/requests',
}
